import React from 'react';
import styles from './ToggleAlisaIvrCompanyState.module.scss';
import { Switch } from 'antd';
import { useShutdownAlisaIvrCompanyStateChange } from '../../../changeAlisaIvrCompanyState/api';
import { shutdownAlisaIvrCompanyQuery } from '../../../../../shared/api/queries';

const { useShutdownAlisaIvrCompany } = shutdownAlisaIvrCompanyQuery;

const ToggleAlisaIvrCompanyState = ({ shutdown }) => {
  const { data: ivrCompany, isFetching: isAlisaActiveFetching } =
    useShutdownAlisaIvrCompany(shutdown.alertId);

  const { change, loading } = useShutdownAlisaIvrCompanyStateChange();

  const checkedValue = Boolean(ivrCompany);

  return (
    <div className={styles.root}>
      По всей УК
      <Switch
        size="small"
        loading={isAlisaActiveFetching || loading || false}
        checked={checkedValue}
        onChange={(checked) => {
          change({ shutdownId: shutdown.alertId, data: checked ? 1 : 0 });
        }}
      />
    </div>
  );
};

export default ToggleAlisaIvrCompanyState;
